import { createFileRoute, redirect } from "@tanstack/react-router";
import StateLevelReportsPage from "@/components/state-level-report/reports/StateLevelReportsPage";

type ReportsSearch = {
  report?: string;
};

export const Route = createFileRoute("/$leaid/_error-wrapper/admin/reports")({
  validateSearch: (search: Record<string, unknown>): ReportsSearch => ({
    report: typeof search.report === "string" ? search.report : undefined,
  }),
  beforeLoad: ({ context, params }) => {
    if (params.leaid !== "0-" || !context.hasRole("ADMIN")) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: StateLevelReportsPage,
});
